module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-03-6188b7a7489841c71efe9c2d7f64ee06.jpg";